// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__33GHz","content":"styles_content__15qAk","selectAll":"styles_selectAll__1xf3_"};